export default {
	setScreenSize: ({ commit }) => {
		commit('setScreenSize');
	},
	setLocalStorage: ({ commit }, data) => {
		commit('setLocalStorage', data);
	},
	clearLocalStorage: () => {
		localStorage.clear();
	},
	setCompany: ({ commit }, company) => {
		commit('setCompany', company);
	},
	getCompany: ({ state }, companyId) => {
		return axios.get(`/api/companies/${companyId}`);
	},
	getCountries: ({ commit, state }, force = false) => {
		if (_.isEmpty(state.countries) || force) {
			axios.get('/api/options/countries').then(
				({
					data: {
						data: { countries }
					}
				}) => {
					commit('setCountries', countries);
				}
			);
		}
	},
	getCities: ({ commit, state }, force = false) => {
		if (_.isEmpty(state.cities) || force) {
			axios.get('/api/options/cities').then(
				({
					data: {
						data: { cities }
					}
				}) => {
					commit('setCities', cities);
				}
			);
		}
	}
};
